import type { Metadata, PaginationParams } from '@/types';
import type { MeetingData } from '../../types';

import { axiosClient } from '@/lib/axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';

type ResponseData = {
  data: MeetingData[];
  metadata: Metadata;
};

type Params = {
  companyID: number;
  queryParams?: {
    sort_by?: keyof MeetingData;
    sort_dir?: 'asc' | 'desc';
    q?: string;
  } & PaginationParams;
};

export const getMeetings = async ({ companyID, queryParams }: Params): Promise<ResponseData> => {
  const { data } = await axiosClient.get<ResponseData>(`/companies/${companyID}/meetings`, {
    params: queryParams,
  });
  return data;
};
type QueryFnType = typeof getMeetings;

type UseGetMeetingsOptions = {
  companyID: number;
  queryParams?: Params['queryParams'];
  config?: QueryFunction<QueryFnType>;
};

export const useGetMeetings = ({ companyID, queryParams, config }: UseGetMeetingsOptions) => {
  return useQuery({
    queryKey: ['meetings', companyID, queryParams],
    queryFn: () => getMeetings({ companyID, queryParams }),
    ...config,
  });
};
